module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_03.d7dd6bfc.png";